import React from 'react';
import "./SocialIcon.sass";

import cx from 'classnames';

export default class SocialIcon extends React.PureComponent {
  render() {
    const {network} = this.props;

    return (
      <span className={cx("social-icon", `social-icon--${network}`)}/>
    );
  }
}



// WEBPACK FOOTER //
// ./components/socialIcon/SocialIcon.js